import {appConstants} from '../_constants';
import {initialState} from "../_store";

export function serviceTypes(state=initialState.serviceTypes, action) {
    switch (action.type) {
        case appConstants.SERVICETYPE_SUCCESS:
            return action.serviceTypes;
        default:
            return state
      }
}


// WEBPACK FOOTER //
// ./src/_reducers/serviceType.reducer.js